import { render, staticRenderFns } from "./RelatedAPIsSection.vue?vue&type=template&id=98de2700&"
import script from "./RelatedAPIsSection.vue?vue&type=script&lang=js&"
export * from "./RelatedAPIsSection.vue?vue&type=script&lang=js&"
import style0 from "./RelatedAPIsSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports